// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ValidateBillingAddress,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import { CustomerValidationDto } from "@insite/client-framework/Types/ApiModels";

function checkIfAddressValidatioRequired(validation?: CustomerValidationDto | null) {
    const shouldValidate =
        validation &&
        (validation.firstName?.isDisabled === false ||
            validation.lastName?.isDisabled === false ||
            validation.companyName?.isDisabled === false ||
            validation.attention?.isDisabled === false ||
            validation.address1?.isDisabled === false ||
            validation.address2?.isDisabled === false ||
            validation.address3?.isDisabled === false ||
            validation.address4?.isDisabled === false ||
            validation.city?.isDisabled === false ||
            validation.state?.isDisabled === false ||
            validation.country?.isDisabled === false ||
            validation.postalCode?.isDisabled === false ||
            validation.phone?.isDisabled === false ||
            validation.email?.isDisabled === false ||
            validation.fax?.isDisabled === false);
    return shouldValidate;
}

export const CustomValidateBillingAddress: typeof ValidateBillingAddress = async props => {
    if (checkIfAddressValidatioRequired(props.billTo.validation)) {
        await ValidateBillingAddress(props);
    }
};

export const CustomValidateShippingAddress: typeof ValidateShippingAddress = async props => {
    if (checkIfAddressValidatioRequired(props.shipTo?.validation)) {
        await ValidateShippingAddress(props);
    }
};

replaceInChain(chain, ValidateBillingAddress, CustomValidateBillingAddress);
replaceInChain(chain, ValidateShippingAddress, CustomValidateShippingAddress);
